import * as React from 'react';
import * as style from './style.css';
import { IconHeartOn24 } from '@cian/ui-kit';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SkeletonRow = function SkeletonRow() {
  return /*#__PURE__*/_jsxs("div", {
    className: style['row'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['offer-title'],
      children: [/*#__PURE__*/_jsx("div", {
        className: style['offer-title-link']
      }), /*#__PURE__*/_jsx("div", {
        className: style['labels']
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style['description-cell']
    }), /*#__PURE__*/_jsx("div", {
      className: style['description-cell']
    }), /*#__PURE__*/_jsx("div", {
      className: style['description-cell']
    }), /*#__PURE__*/_jsxs("div", {
      className: style['description-controls'],
      children: [/*#__PURE__*/_jsx("div", {
        className: style['compare']
      }), /*#__PURE__*/_jsx(IconHeartOn24, {
        color: "current_color"
      })]
    })]
  });
};